import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText
} from '@mui/material';
import {findCode, fullCopy, printVariable} from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import {Grid} from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";

// quill
import ReactQuill, {Quill} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import ConfirmDialog from '@components/ConfirmDialog';
import useAlert from '@hooks/useAlert'
const TeacherAttdncPartCare = ({bing, dialogHandler, showPost, callback}) =>  {
  console.log('bing=>', bing)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const postHandler = useState(false)
  // redux
  const codes = useSelector(state => state.codeReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const editorRef = useRef();
  const { alert, renderAlert } = useAlert()
  let msg = ''
  if(bing.statCode === 'S000') {
    msg = `${bing.studentName} (${schola.name} ${bing.grade}학년 ${bing.className}반 ${bing.classNum}번) 학생이 ${bing.title} 수업에 출석전이므로 확인 부탁드립니다.`
  }
  else if(bing.statCode === 'S206' && !bing.remark) {
    msg = `${bing.studentName} (${schola.name} ${bing.grade}학년 ${bing.className}반 ${bing.classNum}번) 학생이 ${bing.title} 수업에 ${bing.statName} 하였으니 확인 부탁드립니다.`
  }
  else {
    if(bing.chgCode === 'C000') {
      msg = `${bing.studentName} (${schola.name} ${bing.grade}학년 ${bing.className}반 ${bing.classNum}번) 학생이 ${bing.title} 수업에 ${bing.statName} 하였습니다. `
    }
    else {
      msg = `${bing.studentName} (${schola.name} ${bing.grade}학년 ${bing.className}반 ${bing.classNum}번) 학생이 ${bing.title} 수업에 ${bing.statName} 및 ${bing.chgName} 하였습니다. `
    }
  }
  
  const saveBing = async () => {
    const url = `/bing` 
    const newItem = {...bing, id: bing.bingId}
    newItem.userYn = 'Y'
    newItem.uptTime = moment().format(dateFormat)
    const body = {
      bingList: JSON.stringify([newItem])
    }
    openIndicator()
    const resp = await WebService.post(url, body, {
      matchDate: 'Y',
      schoolId: schola.id
    })
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return false
    }
    return true
  }

  const onSend = async () => {
  
    const ret = await saveBing()
    if(!ret) {
      return
    }
    const item = bing
    const title = `${item.title} 알림 (from 강사)`
    const content = msg
    const data = {
      title: title.trim(),
      content: content.trim(),
      studentIds: [item.studentId],
      
    }
    
    const formData = new FormData()
    const jsonData = JSON.stringify(data)
    formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    // formData.append("body", {string: jsonData, type:'application/json'})
    const params = {
      lectureId: item.lectureId,
      etcId: item.studentId,
      schoolId: schola.id
    }
    const url = encodeURI(`/topic/img/${schola.id}/TP06`)

    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      params: params
    })

    closeIndicator()

    if(resp.data.repCode !== 'ack') {
      alert(resp.data.repMessage)
      return
    }
    alert('전송하였습니다.',  () => {
      handleClose()
    })
  }

  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return 
    }
    else {
      dialogHandler[1](false)
    }
  }


  return (
    <Fragment>
      
      <Dialog open={dialogHandler[0]}  onClose={handleClose} maxWidth='sm' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            알림전송
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <br/>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>
                {msg}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button style={{margin:5}} onClick={handleClose} >
            취소
          </Button>
          <Button style={{margin:5}} onClick={() => {
            // handleClose()
            showPost()
            
          }}>
            직접 입력
          </Button>
          <ConfirmDialog
            btn={
              <Button style={{margin:5}} variant='contained' >
                메시지 전송
              </Button>
            }
            title={'알림'}
            content={'학생 보호자에게 메시지를 전송하시겠습니까?'}
            bc={'primary'}
            preHandle={ async () => {
              return true
            }}
            perform={() => {
              onSend()
            }}
        />

          
          
        </DialogActions>
      </Dialog>
      {renderSnackbar()}
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default TeacherAttdncPartCare